export const NEW_NOTIFICATION_TYPE_FROM_SW = 'NEW_NOTIFICATION';

export const LOGO_SQUARE_DEFAULT_URL = '/android-chrome-512x512.png';

export const SHORT_MESSAGE_LENGTH = 220;
